import ComposerGoogleOptions from 'components/Composer/CustomizePostBlock/ComposerGoogleOptions'
import { ComposerGooglePost } from 'shared/types'
import styles from '../BulkPost.pcss'
import { BulkNetworkOptionsProps } from './types'

export function GoogleBulkOptions(props: BulkNetworkOptionsProps) {
  const { post, recycleSelector } = props

  return (
    <ComposerGoogleOptions
      postData={post.data as ComposerGooglePost}
      multipostId={post.id}
      align="right"
      className={styles.googleOptions}
      children={recycleSelector}
    />
  )
}
